import { render } from "./gold.vue?vue&type=template&id=1e0630db&scoped=true"
import script from "./gold.vue?vue&type=script&lang=js"
export * from "./gold.vue?vue&type=script&lang=js"

import "./gold.vue?vue&type=style&index=0&id=1e0630db&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0630db"]])

export default __exports__